import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { NavbarBus } from "../index";

@Component({
    name: 'NavbarItem',
})
export default class NavbarItem extends Vue {
    private static componentUuid = 0;
    private readonly uuid!: number;

    @Prop() value!: boolean;
    @Prop() ignoreClick!: boolean;
    @Prop({ default: "w-full lg:w-8/12 xxl:w-7/12" }) customClass!: string;

    constructor() {
        super();
        this.uuid = ++NavbarItem.componentUuid;
    }

    @Watch("value")
    onValueChange() {
        if (this.value) {
            NavbarBus.$emit('open', this.uuid);
        } else {
            NavbarBus.$emit('close', this.uuid);
        }
    }

    mounted() {
        NavbarBus.$on('opened', (id: number) => {
            if (this.uuid !== id) {
                this.$emit('input', false);
            }
        })
        if (this.value) {
            NavbarBus.$emit('open', this.uuid);
        }
    }

    public toggle(force: boolean) {
        if (this.ignoreClick && !force) { return; }
        this.$emit('input', !this.value);
    }

    destroyed() {
        this.$emit('input', false);
        NavbarBus.$emit('close', this.uuid);
    }
}

